
import React, { useState, useEffect } from "react";
import { ProgressBar } from "react-bootstrap";
import { MdAccessTime } from "react-icons/md";
import { FiTarget } from "react-icons/fi";
import { CiCircleCheck } from "react-icons/ci";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import '../../App.css';
export default function DashboardPage({ onProcessClick }) {
  const [totalproduction, setTotalproduction] = useState({});
  const [machineassigned, setMachineassigned] = useState([]);
  const [productName, setProductName] = useState('')
  const [shift, setShift] = useState('')

  // useEffect(() => {
  //   fetchtotalproduction();
  //   fetchMachineassigned();
  // }, []);


  useEffect(() => {
    fetchtotalproduction();
    fetchMachineassigned();

    const interval = setInterval(() => {
      fetchtotalproduction();
      fetchMachineassigned();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const fetchtotalproduction = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const response = await axios.get(`${config.API}/operator/totalproduction`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        const data = response.data || {};
        setTotalproduction(data);
      } else {
        console.error("Unexpected status:", response.status);
        setTotalproduction({});
      }
    } catch (err) {
      console.error("Error fetching total production:", err.message);
      setTotalproduction({});
    }
  };
  const fetchMachineassigned = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const response = await axios.get(`${config.API}/operator/machineassigned`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        const data = response.data?.machine || [];
        const productName = response?.data?.product || '';
        const shift = response?.data?.shift || ''
        setMachineassigned(data);
        setProductName(productName);
        setShift(shift)
      } else {
        console.error("Unexpected status:", response.status);
        setMachineassigned([]);
      }
    } catch (err) {
      console.error("Error fetching machine assigned:", err.message);
      setMachineassigned([]);
    }
  };

  return (
    <div className="container-fluid mt-3 font_family">
      <div className="row productionBox">
        <InfoCard
          title="Total Production"
          value={totalproduction?.total_production || 0}
          subtitle={`${totalproduction?.product} produced today`}
          color="text-primary"
        />
        <InfoCard
          title="Daily Target"
          value={totalproduction?.daily_target || 0}
          subtitle={`${totalproduction?.product} produced today`}
        />
        <InfoCard
          title="Completion"
          value={`${Number(totalproduction?.productivity || 0).toFixed(2)}%`}
          subtitle={`${totalproduction?.product} Overall progress`}
          color="text-success"
        />
      </div>
      <h5 className="fw-bold product_machine_name">Production Targets</h5>
      <div className="row targetsBox">
        {machineassigned?.length === 0 ? (
          <div className="col-12 text-center my-5">
            <h2 className="text-muted">Coming Soon...</h2>
          </div>
        ) : (
          machineassigned.map((item, index) => {
            const capacity = item?.machine?.capacity || 0;
            const completed = item?.total_produced || 0;
            const remaining = capacity - completed;
            const percent = capacity > 0
              ? Number(((completed / capacity) * 100).toFixed(2))
              : 0;
            const processName = item?.machine?.type || "";
            const machineName = item?.machine?.name || "Unnamed Process";
            const machineCode = item?.machine?.machine_code
            return (
              <div className="col-12 col-sm-6 col-lg-4 mb-4" key={index}>
                <div className="p-3 rounded shadow-sm bg-white h-100" style={{ cursor: "pointer" }}
                  onClick={() =>
                    processName && onProcessClick(processName, item?.machine?.id, machineName, machineCode, productName)
                  }>
                  <h6 className="fw-bold text-truncate text-wrap product_machine_name">{machineName} , {machineCode}</h6>

                  <p className="mb-1 text-wrap">
                    <MdAccessTime className="fs-5" /> {shift || "08:00 - 16:00"}
                  </p>

                  <div className="d-flex justify-content-between small flex-wrap">
                    <span className="me-2 text-wrap">
                      <FiTarget className="text-primary fs-5" /> Target: {capacity} pieces
                    </span>
                    <span className="text-wrap">
                      <CiCircleCheck className="text-success fs-5" /> Completed: {completed} pieces
                    </span>
                  </div>
                  <ProgressBar
                    now={percent}
                    variant="dark"
                    className="my-2"
                    style={{ height: "10px", borderRadius: "3px" }}
                  />
                  <div className="d-flex justify-content-between small flex-wrap">
                    <span>Completion: {percent}%</span>
                    <span className="text-wrap">
                      <AiOutlineExclamationCircle className="text-warning fs-5" /> Remaining: {remaining} pieces
                    </span>
                  </div>

                  <div className="mt-2 text-end">
                    <p
                      className="small text-muted mb-0"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        processName && onProcessClick(processName, item?.machine?.id, machineName, machineCode, productName)
                      }
                    >
                      Click to log production
                    </p>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

function InfoCard({ title, value, subtitle, color = "text-dark" }) {
  return (
    <div className="col-md-4 col-sm-4 mb-3 infoCol">
      <div className="p-3 rounded bg-white shadow-sm box ">
        <h6 className="text-dark mb-1 product_machine_name fw-bold">{title}</h6>
        <h6 className=" text-muted product_machine_name ">{subtitle}</h6>
        <h4 className={`fw-bold ${color} textSize`}>{value}</h4>
      </div>
    </div>
  );
}
